module.exports = __webpack_public_path__ + "media/images/bannerImage4-e04bb7cff122d6431154756e877b0340.jpg";